var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.minimized)?_c('span',{staticClass:"arrow"},[_vm._v("")]):[_c('span',{staticClass:"arrow"},[_vm._v("")])],_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }